import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { StorageManager } from "@/features/admin/components/storage-manager";
import { PageContainer } from "@fleet/ui";

function AdminStoragePage() {
  return (
    <PageContainer maxWidth="5xl">
      <StorageManager />
    </PageContainer>
  );
}

export const adminStorageRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/storage",
  component: AdminStoragePage,
});
